import { FORM_QUERY_PARAM } from "@/utilities/formQuery";

import type { Form, News, Page } from "@/payload-types";

type LinkReference = {
  relationTo: "pages" | "news" | "forms";
  value: Page | News | Form | string | number;
};

function resolveFormIdentifier(value: LinkReference["value"]) {
  if (typeof value === "string" || typeof value === "number") {
    const identifier = String(value).trim();
    return identifier || null;
  }

  if (!value || typeof value !== "object") return null;

  if ("id" in value && value.id != null) {
    const identifier = String(value.id).trim();
    if (identifier) return identifier;
  }

  if ("title" in value && typeof value.title === "string") {
    const identifier = value.title.trim();
    if (identifier) return identifier;
  }

  return null;
}

export function resolveReferenceHref(
  reference: LinkReference | null | undefined,
) {
  if (!reference) return null;

  if (reference.relationTo === "forms") {
    const formIdentifier = resolveFormIdentifier(reference.value);
    if (!formIdentifier) return null;

    return `?${new URLSearchParams({ [FORM_QUERY_PARAM]: formIdentifier }).toString()}`;
  }

  if (
    typeof reference.value === "object" &&
    reference.value &&
    "slug" in reference.value &&
    typeof reference.value.slug === "string"
  ) {
    return `${reference.relationTo !== "pages" ? `/${reference.relationTo}` : ""}/${
      reference.value.slug
    }`;
  }

  return null;
}
